import React, { useEffect } from "react";
import styles from "../style/ContactPage.module.css"; 

function ContactPage() {
    useEffect(() => {
        // Automatically redirects the user to the external URL
        window.location.href = "https://awn-projekte.de/kontakt/";
    }, []);

    return (
        <div className={styles.pageContainer} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
            <div style={{ textAlign: "center" }}>
                <h2>Weiterleitung...</h2>
                <p>Sie werden zur Kontaktseite weitergeleitet.</p>
                <p>
                    Falls die Weiterleitung nicht funktioniert, <a href="https://awn-projekte.de/kontakt/">klicken Sie bitte hier</a>.
                </p>
            </div>
        </div>
    );
}

export default ContactPage;